import React, { useCallback, useEffect, useState } from "react";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  AddPurchaseOrderApi,
  getAccList,
  GetAllTerms,
  getPartDataListByCompStoreFilter,
  GetAllPaymentStatus,
  GetAllShipMethod,
  GetAllPOStatus,
  GetVendorById,
  GetVendListByStore,
  PrintPurchaseOrderApi,
  GetPurchaseOrderDataByID,
  GetPurchaseOrderPartsByID,
  GetAllPOAddress,
} from "../../api";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/sale.css";
import { Card } from "react-bootstrap";
import "../../styles/viewCustomer.css";
import { Col, Container, Row } from "react-bootstrap";
import { Header } from "../../components";
import { validateField } from "../../contexts/Utils";
import DateTimeField from "../../components/DateTimeField";
import Select from "react-select";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import LoadingIndicator from "../LoadingIndicator";
import CartListTable from "../../components/CartListTable";
import PosForm2 from "../../components/PosForm2";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";

const AddPurchaseOrder = () => {
  const {
    currentColor,
    defaultImageMode,
    imageMode,
    setActiveProdMenu,
    setActiveProdMenuId,
    storeG,
    companyG,
    userID,
  } = useStateContext();
  const [VendorOptions, setVendorOptions] = useState([]);
  const [poStatusOptions, setPoStatusOptions] = useState([]);
  const [termsOptions, setTermsOptions] = useState([]);
  const [paymentStatusOptions, setPaymentStatusOptions] = useState([]);
  const [shipMethodOptions, setShipMethodOptions] = useState([]);
  const [poAddressOptions, setPoAddressOptions] = useState([]);
  const [partOptions, setPartOptions] = useState([]);
  const [accountOptions, setAccountOptions] = useState([]);
  const [store_id, setStore_id] = useState(0);
  const [company_id, setCompany_id] = useState(0);
  const [CartList, setCartList] = useState([]);
  const [isPageFrozen, setIsPageFrozen] = useState(false);

  const [formData, setFormData] = useState({
    vendor: "select",
    vendor_invoice_no: "",
    po_revision: "",
    terms: "select",
    payment_status: "select",
    ship_method: "select",
    account: "select",
    tracking_no: "",
    r_to: "",
    r_street: "",
    r_city: "",
    r_state: "",
    r_zip: "",
    r_country: "",
    r_phone: "",
    s_to: "",
    s_street: "",
    s_city: "",
    s_state: "",
    s_zip: "",
    s_country: "",
    s_phone: "",
    amount_paid: 0,
    amount_pending: 0,
    sub_total: 0,
    total_items: 0,
    grand_total: 0,
    tax: 0,
    shipping: 0,
    note: "",
    store_id: 0,
    company_id: 0,
    status: "select",
    o_datetime: "",
  });
  const [partData, setPartData] = useState({
    type: "part",
    part: "select",
    qty: "1",
    price: "0",
    mfgOptions: [],
    mfg: "select",
  });
  const [oDatetime, setODatetime] = useState("");
  const [errors, setErrors] = useState([]);
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "part") {
      setPartData((prev) => ({
        ...prev,
        part: {
          ...prev.part,
          description: value,
        },
      }));
    }
    if (["qty", "price"].includes(name))
      setPartData((prev) => ({ ...prev, [name]: value }));
    else if (
      ["quantity", "unit_price", "notes", "expected_date"].includes(name)
    ) {
      const index = parseInt(e.target.getAttribute("data-index"));
      setCartList((prev) =>
        prev.map((item, i) => {
          if (i !== index) return item;
          const updated = { ...item, [name]: value };
          return {
            ...updated,
            total:
              parseFloat(updated.quantity) * parseFloat(updated.unit_price) ||
              0,
          };
        }),
      );
    } else if (name === "account") {
      const acc = accountOptions?.find((item) => item.label === e.target.value);
      setFormData((prev) => ({ ...prev, account: acc }));
    } else if (name === "status") {
      const ss = poStatusOptions?.find((item) => item.label === e.target.value);
      setFormData((prev) => ({ ...prev, status: ss }));
    } else if (["tax", "shipping", "amount_paid"].includes(name))
      setFormData((prev) => ({ ...prev, [name]: value }));
    else setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = async (option, e) => {
    if (option && option.value) {
      if (e.name === "part") {
        const { mfg_names = [], mfg_pns = [] } = option.approved_mfg || {};
        const mfgOptions = mfg_names.map((name, i) => {
          const label = `${name} - ${mfg_pns[i]}`;
          return { label, value: label, mfg_name: name, mfg_pn: mfg_pns[i] };
        });
        setPartData((prev) => ({
          ...prev,
          [e.name]: option,
          qty: 1,
          price: option.cost_price,
          mfgOptions: mfgOptions,
          mfg: "select",
        }));
      } else if (e.name === "mfg")
        setPartData((prev) => ({ ...prev, [e.name]: option }));
      else if (e.name === "vendor") {
        await GetVendorById(option.value)
          .then((result) => {
            setFormData((prev) => ({
              ...prev,
              vendor: option,
              terms: result.data.term
                ? { label: result.data.term, value: result.data.term_id }
                : "select",
              r_to: result.data.name || "",
              r_street: result.data.r_street || "",
              r_city: result.data.r_city || "",
              r_state: result.data.r_state || "",
              r_zip: result.data.r_zip || "",
              r_country: result.data.r_country || "",
              r_phone: result.data.r_phone || "",
              s_to: result.data.s_attention_name || "",
              s_street: result.data.s_street || "",
              s_city: result.data.s_city || "",
              s_state: result.data.s_state || "",
              s_zip: result.data.s_zip || "",
              s_country: result.data.s_country || "",
              s_name: result.data.s_attention_name || "",
              s_phone: result.data.s_phone || "",
            }));
          })
          .catch((err) => console.log(err.message));
      } else if (e.name === "po_address") {
        setFormData((prev) => ({
          ...prev,
          po_address: option,
          r_to: option.r_to || "",
          r_street: option.r_street || "",
          r_city: option.r_city || "",
          r_state: option.r_state || "",
          r_zip: option.r_zip || "",
          r_country: option.r_country || "",
          r_phone: option.r_phone || "",
          s_to: option.s_to || "",
          s_street: option.s_street || "",
          s_city: option.s_city || "",
          s_state: option.s_state || "",
          s_zip: option.s_zip || "",
          s_country: option.s_country || "",
          s_name: option.s_name || "",
          s_phone: option.s_phone || "",
        }));
      } else setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else {
      if (e.name === "part")
        setPartData((prev) => ({ ...prev, [e.name]: "select" }));
      else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
    }
  };

  const handleRadioChange = (name) => {
    if (name === "part")
      setPartData((prev) => ({
        ...prev,
        type: name,
        part: "select",
        qty: 1,
        price: 0,
        mfgOptions: [],
        mfg: "select",
      }));
    else if (name === "np")
      setPartData((prev) => ({
        ...prev,
        type: name,
        part: {
          label: `NP`,
          value: null,
          part_number: "NP",
          description: "",
          category: "=",
          unit: "-",
          sale_price: 0,
          cost_price: 0,
          bom_str: "",
          nonpart: true,
        },
        qty: 1,
        price: 0,
        mfgOptions: [],
        mfg: "select",
      }));
  };

  const loadOptions = async (inputText, callback) => {
    if (inputText.length > 2 && store_id) {
      await getPartDataListByCompStoreFilter(company_id, store_id, inputText)
        .then((resp) => {
          const partOptions1 = resp.data.map((item) => ({
            label: `${item.part_number} - ${item.description}`,
            value: item.part_id,
            part_number: item.part_number,
            description: item.description,
            category: item.category,
            unit: item.unit,
            sale_price: item.sale_price,
            cost_price: item.cost_price,
            bom_str: item.bom_str,
            approved_mfg: item.approved_mfg,
            nonpart: false,
          }));
          setPartOptions(partOptions1 || []);
          callback(partOptions1 || []);
        })
        .catch((err) => console.log(err.message));
    } else callback(partOptions);
  };

  const handleCopyClick = (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setFormData((prev) => ({
      ...prev,
      s_to: formData.r_to,
      s_street: formData.r_street,
      s_city: formData.r_city,
      s_state: formData.r_state,
      s_zip: formData.r_zip,
      s_phone: formData.r_phone,
      s_country: formData.r_country,
    }));
  };

  const handleAddcartClick = () => {
    TimeoutUtility.resetTimeout();
    const newErrors = {};
    Object.keys(partData).forEach((key) => {
      const error = validateField(key, partData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    const defaultPart = {
      part_id: partData.part.value,
      name: partData.part.label,
      part_number: partData.part.part_number,
      details: partData.part.description,
      unit_price: parseFloat(partData.price),
      unit: partData.part.unit,
      cost_price: partData.part.cost_price,
      quantity: parseFloat(partData.qty),
      mfg_name: partData.mfg.mfg_name,
      mfg_pn: partData.mfg.mfg_pn,
      discount: 0,
      total: parseFloat(partData.price) * parseFloat(partData.qty),
      received_qty: 0,
      image: null,
      expected_date: "",
      notes: "",
    };
    setPartData({
      type: "part",
      part: "select",
      price: "0",
      qty: "1",
      mfgOptions: [],
      mfg: "select",
    });
    setCartList((prevPartList) => [...prevPartList, defaultPart]);
  };

  const handlePurchaseOrderClick = async (e, print_f = false) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setIsPageFrozen(true);

    const newErrors = {};
    let lasterr = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) {
        lasterr = { key: key, error: error };
        newErrors[key] = error;
      }
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      showErrorToast("Error!", ToTitle(lasterr.key) + " - " + lasterr.error);
      setIsPageFrozen(false);
      return;
    }
    if (CartList.length === 0) {
      showErrorToast("Error!", "Purchase Order Cart is empty!");
      setIsPageFrozen(false);
      return;
    }
    const uniqueValues = new Set(
      CartList.map((v) => String(v.part_id) + v.details + v.notes),
    );
    if (uniqueValues.size < CartList.length) {
      showErrorToast(
        "Error!",
        `Duplicate description and notes for same parts found.\nPurchase Order failed to create!`,
      );
      setIsPageFrozen(false);
      return;
    }
    const hasUnshippedQty = CartList.some(
      (item) => parseInt(item.quantity) > parseInt(item.received_qty),
    );
    if (formData.status.value === 1701) {
      if (
        (hasUnshippedQty &&
          !window.confirm(
            "Quantity is not completely received.\nStill want to Close the Order?",
          )) ||
        (!hasUnshippedQty &&
          formData.amount_pending > 0 &&
          !window.confirm(
            "Amount is still pending.\nStill want to Close the Order?",
          ))
      ) {
        setIsPageFrozen(false);
        return;
      }
    }
    try {
      const cartItems = CartList.map((item, i) => ({
        po_id: 0,
        item_no: i + 1,
        part_id: item.part_id,
        part_number: item.part_number,
        part_description: item.details,
        quantity: parseFloat(item.quantity) || 0,
        price: parseFloat(item.unit_price) || 0,
        exp_rec_date: item.expected_date || null,
        mfg_name: item.mfg_name,
        mfg_pn: item.mfg_pn,
        item_note: item.notes,
      }));
      var mainFormData = {
        po_revision: formData.po_revision,
        order_date: oDatetime,
        store_id: store_id,
        vendor_id: formData.vendor.value,
        account_to_id: formData.vendor.account_id,
        account_from_id: formData.account.value,
        vendor_invoice_no: formData.vendor_invoice_no,
        user_id: userID,
        po_status_id: formData.status.value,
        term_id: formData.terms !== "select" ? formData.terms.value : null,
        payment_status_id:
          formData.payment_status !== "select"
            ? formData.payment_status.value
            : null,
        amount_paid: formData.amount_paid,
        amount_pending: formData.amount_pending,
        tax: formData.tax,
        shipment: formData.shipping,
        total_price: formData.grand_total,
        ship_method_id:
          formData.ship_method !== "select" ? formData.ship_method.value : null,
        tracking_no: formData.tracking_no,
        po_note: formData.note,
        company_id: company_id,
        purchase_order_parts: cartItems,
        purchase_order_address: {
          po_id: 0,
          vendor_id: formData.vendor.value,
          title: "",
          remit_to: formData.r_to,
          remitting_address: {
            street: formData.r_street,
            city: formData.r_city,
            state: formData.r_state,
            zip: formData.r_zip,
            country: formData.r_country,
            phone: formData.r_phone,
          },
          ship_to: formData.s_to,
          shipping_address: {
            street: formData.s_street,
            city: formData.s_city,
            state: formData.s_state,
            zip: formData.s_zip,
            country: formData.s_country,
            attention_name: "",
            phone: formData.s_phone,
          },
          user_created: false,
        },
      };
      const response = await AddPurchaseOrderApi(mainFormData);
      if (response.success) {
        if (print_f && response.data.po_id) {
          const resp = await PrintPurchaseOrderApi(response.data.po_id);
          if (!resp) showErrorToast("Error!", "Print Record not found!");
        }
        showSuccessToast("Success!", "Purchase order added successfully.");
      } else {
        showErrorToast(
          "Error!",
          "Purchase order failed to add!\n\n" + response.message,
        );
        setIsPageFrozen(false);
        return;
      }
      setTimeout(function () {
        window.location.reload();
      }, 1000);
    } catch (err) {
      showErrorToast("Error!", "Purchase order failed to add!");
    } finally {
      setIsPageFrozen(false);
    }
  };

  const handlePrintOrderClick = async (e) => handlePurchaseOrderClick(e, true);

  const handleToggle = (value) => {
    if (value.part_id) {
      TimeoutUtility.resetTimeout();
      setActiveProdMenuId({ part_id: value.part_id, store_id: store_id });
      setActiveProdMenu(true);
    }
  };

  const handleNewClick = () =>
    window.open(`/Purchase/AddPurchaseOrder`, "_blank");

  const handleClearClick = () =>
    window.confirm(`Are you sure you want to Clear the Purchase order?`) &&
    window.location.reload();

  function ToTitle(snakeCaseString) {
    const spacedString = snakeCaseString.replace(/_/g, " ");
    const titleCaseString = spacedString.replace(/\b\w/g, (char) =>
      char.toUpperCase(),
    );
    return titleCaseString;
  }

  const formatCurrency = (number) => {
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
  };

  const handleDeleteClick = async (str) => {
    TimeoutUtility.resetTimeout();
    const index = CartList.findIndex(
      (item) => String(item.part_id) + item.details + item.notes === str,
    );
    const rP = CartList[index];
    if (window.confirm(`Do you want to remove ${rP.part_number} from cart?`)) {
      const newCartList = [...CartList];
      newCartList.splice(index, 1);
      setCartList(newCartList);
    }
  };

  const updateTotals = useCallback(() => {
    if (!CartList?.length) return;
    let taxx = parseFloat(formData.tax) || 0;
    let ship = parseFloat(formData.shipping) || 0;
    let ampd = parseFloat(formData.amount_paid) || 0;

    const { totalAmt, totalItm } = CartList.reduce(
      (acc, item) => {
        acc.totalAmt += parseFloat(item.total);
        acc.totalItm += parseFloat(item.quantity) || 0;
        return acc;
      },
      { totalAmt: 0, totalItm: 0 },
    );
    taxx = (taxx / 100) * totalAmt;
    var grandTotal = totalAmt + taxx + ship;
    var amountPend = grandTotal - ampd;

    setFormData((prev) => ({
      ...prev,
      sub_total: totalAmt,
      total_items: totalItm,
      grand_total: grandTotal,
      amount_pending: amountPend,
    }));
  }, [CartList, formData.tax, formData.shipping, formData.amount_paid]);

  useEffect(() => {
    updateTotals();
  }, [updateTotals]);

  useEffect(() => {
    if (companyG?.company_id) setCompany_id(companyG.company_id);
  }, [companyG]);

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id) {
        TimeoutUtility.resetTimeout();
        setloading(true);
        var now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        setODatetime(now.toISOString().slice(0, 19));
        let storeId = storeG.store_id;
        let cusCopId = null;
        if (localStorage.getItem("copyPOrder")) {
          const cP = localStorage.getItem("copyPOrder");
          if (cP && cP !== "null" && cP >= 200000) {
            await GetPurchaseOrderDataByID(cP)
              .then((resp) => {
                storeId = resp.data.store_id;
                cusCopId = resp.data.vendor_id;
                setFormData((prev) => ({
                  ...prev,
                  terms: resp.data.term
                    ? { label: resp.data.term, value: resp.data.term_id }
                    : "select",
                  r_to: resp.data.remit_to || "",
                  r_street: resp.data.r_street || "",
                  r_city: resp.data.r_city || "",
                  r_state: resp.data.r_state || "",
                  r_zip: resp.data.r_zip || "",
                  r_country: resp.data.r_country || "",
                  r_phone: resp.data.r_phoner || "",
                  s_to: resp.data.ship_to || "",
                  s_street: resp.data.s_street || "",
                  s_city: resp.data.s_city || "",
                  s_state: resp.data.s_state || "",
                  s_zip: resp.data.s_zip || "",
                  s_country: resp.data.s_country || "",
                  s_phone: resp.data.s_phone || "",
                  store_id: resp.data.store_id || 0,
                }));
              })
              .catch((err) => console.log(err.message));
            await GetPurchaseOrderPartsByID(cP)
              .then((result) => {
                if (result.data && result.data.length > 0) {
                  const partList = result.data.map((item) => {
                    return {
                      part_id: item.non_part ? null : item.part_id,
                      name: `${item.part_number} - ${item.part_description}`,
                      part_number: item.part_number || "",
                      details: item.part_description || "",
                      unit_price: item.price || 0,
                      unit: item.unit || "-",
                      cost_price: item.cost_price || 0,
                      quantity: item.quantity || 0,
                      discount: 0,
                      total:
                        parseFloat(item.price) * parseFloat(item.quantity) || 0,
                      mfg_name: item.mfg_name || "",
                      mfg_pn: item.mfg_pn || "",
                      received_qty: item.quantity_received || 0,
                      image: null,
                      expected_date: item.exp_rec_date
                        ? item.exp_rec_date.split("T")[0]
                        : "",
                      notes: item.item_note || "",
                    };
                  });
                  setCartList(() => [...partList]);
                }
              })
              .catch((err) => console.log(err.message));
          }
          localStorage.setItem("copyPOrder", null);
        }
        trackPromise(
          Promise.all([
            getAccList(storeG.store_id),
            GetVendListByStore(storeG.store_id),
            GetAllPOStatus(),
            GetAllTerms(),
            GetAllPaymentStatus(),
            GetAllShipMethod(),
            GetAllPOAddress(),
          ])
            .then(([accRes, cstRes, sstRes, trmRes, payRes, shpRes, poRes]) => {
              setStore_id(storeId);
              let acc = "select",
                sos = "select";
              const accOptions = accRes.data.map((item) => ({
                label: item.name,
                value: item.account_id,
                balance: item.balance,
                open_datetime: item.open_datetime,
              }));
              setAccountOptions(accOptions || []);
              if (accOptions.length > 0) acc = accOptions[0];
              const custOption = cstRes.data.map((item) => ({
                label: item.name,
                value: item.vendor_id,
                balance: item.balance,
                account_id: item.account_id,
                term_id: item.term_id,
              }));
              const custCop = cusCopId
                ? custOption.find((item) => item.value === cusCopId)
                : "select";
              setVendorOptions(custOption || []);
              const type1Options = sstRes.data.map((item) => ({
                label: item.name,
                value: item.po_status_id,
              }));
              setPoStatusOptions(type1Options || []);
              if (type1Options.length > 0) sos = type1Options[0];
              const typeOptions = trmRes.data.map((item) => ({
                label: item.name,
                value: item.term_id,
              }));
              setTermsOptions(typeOptions || []);
              const type2Options = payRes.data.map((item) => ({
                label: item.name,
                value: item.payment_status_id,
              }));
              setPaymentStatusOptions(type2Options || []);
              const type3Options = shpRes.data.map((item) => ({
                label: item.name,
                value: item.ship_method_id,
              }));
              setShipMethodOptions(type3Options || []);
              const type4Options = poRes.data.map((item) => ({
                label: item.title,
                value: item.address_id,
                r_to: item.remit_to || "",
                r_street: item.r_street || "",
                r_city: item.r_city || "",
                r_state: item.r_state || "",
                r_zip: item.r_zip || "",
                r_country: item.r_country || "",
                r_phone: item.r_phone || "",
                s_to: item.ship_to || "",
                s_street: item.s_street || "",
                s_city: item.s_city || "",
                s_state: item.s_state || "",
                s_zip: item.s_zip || "",
                s_country: item.s_country || "",
                s_name: item.s_attention_name || "",
                s_phone: item.s_phone || "",
              }));
              setPoAddressOptions(type4Options || []);
              setFormData((prev) => ({
                ...prev,
                vendor: custCop,
                account: acc,
                status: sos,
                store_id: storeId,
              }));
            })
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
      }
    }
    fetchData();
  }, [storeG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      {(loading || promiseInProgress || isPageFrozen) && (
        <div className="overlay-freeze">
          <LoadingIndicator />
        </div>
      )}
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={1} sm={1} className="p-0 justify-content-center">
          <Col md={7} className="container-col">
            <Header title="CREATE PURCHASE ORDER" />
          </Col>
          <Col md={2} className="container-col">
            <DateTimeField
              label="DateTime:"
              name="order_date"
              value={oDatetime}
              placeholder="DateTime"
              now={false}
              disabled
              style={{ width: "178px" }}
            />
          </Col>
          <Col md={3} className="container-col">
            <label
              className="status-box"
              style={{ backgroundColor: currentColor }}
            >
              Order Status:{" "}
              <select
                name="status"
                className="select status-box-select"
                style={{ backgroundColor: currentColor }}
                value={formData.status.label}
                onChange={handleChange}
              >
                {poStatusOptions.length > 0 &&
                  poStatusOptions?.map((item) => (
                    <option key={item.value}>{item.label}</option>
                  ))}
              </select>
            </label>
          </Col>
        </Row>
        <Row xs={1} sm={1} className="p-0 justify-content-center">
          <Col md={9} className="container-col">
            <div className="card-sale">
              <PosForm2
                formData={formData}
                partData={partData}
                errors={errors}
                currentColor={currentColor}
                CustomerOptions={VendorOptions}
                termsOptions={termsOptions}
                poAddressOptions={poAddressOptions}
                loadOptions={loadOptions}
                type="purchase"
                handleChange={handleChange}
                handleSelectChange={handleSelectChange}
                handleRadioChange={handleRadioChange}
                handleCopyClick={handleCopyClick}
                handleAddcartClick={handleAddcartClick}
              />
              <Row xs={1} sm={1} className="table-container-sale03">
                <CartListTable
                  CartList={CartList}
                  imagePerm={defaultImageMode && imageMode}
                  type="purchase"
                  handleChange={handleChange}
                  handleDelete={handleDeleteClick}
                  handleToggle={handleToggle}
                  handleTotals={updateTotals}
                  loading={promiseInProgress || loading}
                />
              </Row>
            </div>
          </Col>
          <Col md={3} className="container-col">
            <div className="card-sale">
              <Row xs={1} sm={1} className="justify-content-center p-0">
                <Col md={6} className="container-col left-card">
                  <Card
                    className="action-btns-card"
                    style={{ background: isPageFrozen ? "#ccc" : currentColor }}
                    onClick={handlePurchaseOrderClick}
                  >
                    <div className="action-btn">SAVE</div>
                  </Card>
                </Col>
                <Col md={6} className="container-col right-card">
                  <Card
                    className="action-btns-card"
                    style={{ background: isPageFrozen ? "#ccc" : currentColor }}
                    onClick={handlePrintOrderClick}
                  >
                    <div className="action-btn">SAVE & PRINT</div>
                  </Card>
                </Col>
              </Row>
              <Row xs={1} sm={1} className="justify-content-center p-0">
                <Col md={6} className="container-col left-card">
                  <Card
                    className="action-btns-card"
                    style={{ background: isPageFrozen ? "#ccc" : currentColor }}
                    onClick={handleNewClick}
                  >
                    <div className="action-btn">NEW</div>
                  </Card>
                </Col>
                <Col md={6} className="container-col right-card">
                  <Card
                    className="action-btns-card"
                    style={{ background: isPageFrozen ? "#ccc" : currentColor }}
                    onClick={handleClearClick}
                  >
                    <div className="action-btn">CLEAR</div>
                  </Card>
                </Col>
              </Row>
              <Row xs={1} sm={1} className="justify-content-center pl-3 pr-3">
                <Col md={6} className="container-col right-table-field">
                  <label>PO Rev Letter:</label>
                  <input
                    type="text"
                    name="po_revision"
                    placeholder="PO Rev Letter"
                    value={formData.po_revision}
                    onChange={handleChange}
                    className="input"
                  />
                  {errors.po_revision && (
                    <p className="label-error-pos">{errors.po_revision}</p>
                  )}
                </Col>
                <Col md={6} className="container-col right-table-field">
                  <label>Payment Status:</label>
                  <Select
                    className={"right-table-field-select"}
                    inputId={"payment_status"}
                    name="payment_status"
                    value={formData.payment_status}
                    options={paymentStatusOptions}
                    placeholder="Select Payment Status"
                    onChange={handleSelectChange}
                  />
                  {errors.payment_status && (
                    <p className="label-error-pos-select">
                      {errors.payment_status}
                    </p>
                  )}
                </Col>
                <Col md={6} className="container-col right-table-field">
                  <label>Ship Method:</label>
                  <Select
                    className={"right-table-field-select"}
                    inputId={"ship_method"}
                    name="ship_method"
                    value={formData.ship_method}
                    options={shipMethodOptions}
                    placeholder="Select Ship Method"
                    onChange={handleSelectChange}
                  />
                  {errors.ship_method && (
                    <p className="label-error-pos-select">
                      {errors.ship_method}
                    </p>
                  )}
                </Col>
                <Col md={6} className="container-col right-table-field">
                  <label>Tracking No:</label>
                  <input
                    type="text"
                    name="tracking_no"
                    value={formData.tracking_no}
                    onChange={handleChange}
                    placeholder="Tracking No"
                    className="input"
                  />
                  {errors.tracking_no && (
                    <p className="label-error-pos">{errors.tracking_no}</p>
                  )}
                </Col>
                <Col md={12} className="container-col right-table-field">
                  <label>Order Notes:</label>
                  <textarea
                    placeholder="Order Notes"
                    name="note"
                    id="note"
                    value={formData.note}
                    onChange={handleChange}
                    className="textarea"
                  />
                  {errors.note && (
                    <p className="label-error-pos">{errors.note}</p>
                  )}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center mt-3 pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Sub Total:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formatCurrency(formData.sub_total)}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Tax:
                </Col>
                <Col md={6} className="container-col p-0 table1-sum-cash">
                  <label style={{ color: currentColor }}>{"%"}</label>
                  <input
                    name="tax"
                    type="number"
                    min="0"
                    // max="100"
                    className="input table1-sum-tb"
                    value={formData.tax}
                    onChange={handleChange}
                    style={{ marginLeft: "2px", color: currentColor }}
                  />
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Shipping:
                </Col>
                <Col md={6} className="container-col p-0 table1-sum-cash">
                  <label style={{ color: currentColor }}>{"$"}</label>
                  <input
                    name="shipping"
                    type="number"
                    min="0"
                    className="input table1-sum-tb"
                    value={formData.shipping}
                    onChange={handleChange}
                    style={{ marginLeft: "6px", color: currentColor }}
                  />
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Amount Paid:
                </Col>
                <Col md={6} className="container-col p-0 table1-sum-cash">
                  <label style={{ color: currentColor }}>{"$"}</label>
                  <input
                    type="number"
                    name="amount_paid"
                    min="0"
                    value={formData.amount_paid}
                    onChange={handleChange}
                    className="input table1-sum-tb"
                    style={{ marginLeft: "6px", color: currentColor }}
                  />
                </Col>
              </Row>{" "}
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Paid From:
                </Col>
                <Col md={6} className="container-col p-0 table1-sum-cash">
                  <select
                    name="account"
                    className="select table1-sum-tb"
                    style={{ color: currentColor, marginLeft: "14px" }}
                    value={formData.account.label}
                    onChange={handleChange}
                  >
                    {accountOptions.length > 0 &&
                      accountOptions?.map((item) => (
                        <option key={item.value}>{item.label}</option>
                      ))}
                  </select>
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Grand Total:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formatCurrency(formData.grand_total)}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Total Items:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formData.total_items || 0}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default AddPurchaseOrder;
